import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {

    rankChannel = new Subject();
    educationChannel = new Subject();
    educationGroupChannel = new Subject();
    echelonChannel = new Subject();
    positionChannel = new Subject();
    positionGradeChannel = new Subject();
    workUnitChannel = new Subject();
    downloadExcel = new Subject();
    
    repository = new IndexRepository()

    constructor() {
        
        this.rankChannel.next({status: apiResponse.INITIAL})
        this.educationChannel.next({status: apiResponse.INITIAL})
        this.educationGroupChannel.next({status: apiResponse.INITIAL})
        this.echelonChannel.next({status: apiResponse.INITIAL})
        this.positionChannel.next({status: apiResponse.INITIAL})
        this.positionGradeChannel.next({status: apiResponse.INITIAL})
        this.workUnitChannel.next({status: apiResponse.INITIAL})
        this.downloadExcel.next({status: apiResponse.INITIAL})
    }
    
    fetchRank = async (query) => {
        try {
            this.rankChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRank(query).then((result) => {
                this.rankChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rankChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    
    fetchEducation = async (query) => {
        try {
            this.educationChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEducation(query).then((result) => {
                this.educationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.educationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchEducationGroup = async (query) => {
        try {
            this.educationGroupChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEducationGroup(query).then((result) => {
                this.educationGroupChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.educationGroupChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    
    fetchEchelon = async (query) => {
        try {
            this.echelonChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEchelon(query).then((result) => {
                this.echelonChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.echelonChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    
    fetchPosition = async (query) => {
        try {
            this.positionChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPosition(query).then((result) => {
                this.positionChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.positionChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchPositionGrade = async (query) => {
        try {
            this.positionGradeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPositionGrade(query).then((result) => {
                this.positionGradeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.positionGradeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchWorkUnit = async (query) => {
        try {
            this.workUnitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchWorkUnit(query).then((result) => {
                this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchDownloadExcel = async (query) => {
        try {
            this.downloadExcel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadExcel(query).then((result) => {
                this.downloadExcel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadExcel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
}

export default IndexBloc